import React from 'react';
import PropTypes from 'prop-types';

import { Badge as MUIBadge } from '@material-ui/core';

export const Badge = props => <MUIBadge {...props} />;

Badge.propTypes = {
  anchorOrigin: PropTypes.object,
  badgeContent: PropTypes.node,
  children: PropTypes.node,
  classes: PropTypes.object,
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),
  component: PropTypes.elementType,
  invisible: PropTypes.bool,
  max: PropTypes.number,
  overlap: PropTypes.oneOf(['rectangular', 'circular']),
  showZero: PropTypes.bool,
  variant: PropTypes.oneOf(['standard', 'dot'])
};

export default Badge;
